<template>
  <div
    class="concept-tag"
    :class="{ black: color === 'black', white: color === 'white' }"
  >
    <div class="label" @click="$emit('click', data)">{{ data.label }}</div>
    <ButtonWithFeedback
      v-if="showRemove"
      class="remove-btn"
      @click="$emit('remove')"
    ></ButtonWithFeedback>
  </div>
</template>

<script>
import ButtonWithFeedback from "@/components/ButtonWithFeedback.vue";
export default {
  name: "ConceptTag",
  components: {
    ButtonWithFeedback,
  },
  props: {
    data: Object,
    color: { type: String, default: "black" },
    showRemove: { type: Boolean, default: true },
  },
};
</script>

<style scoped lang="stylus">
.concept-tag
  align-items: center
  background-color: #fff
  border: 1px solid $golden
  border-radius: 2px
  color: #000
  display: flex
  padding: vw(6px) vw(16px)

  .remove-btn
    m-icon("close", 18)
    margin-left: vw(10px)

  .label
    m-font-size(14, 22)
    m-letter-spacing(20)
    font-weight: 600
    text-transform: capitalize
</style>